/**
 * Page Transition Component
 * Per Design-System.md Section 8.2
 *
 * Specs:
 * - Enter: fade in (200ms)
 * - Exit: none (instant, feels snappier)
 *
 * Implementation: Uses CSS animation triggered by key change
 */

import { useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'

interface PageTransitionProps {
  children: React.ReactNode
  className?: string
}

export function PageTransition({ children, className }: PageTransitionProps) {
  const location = useLocation()

  // Using key to trigger re-mount and animation on route change
  return (
    <div
      key={location.pathname}
      className={cn(
        'animate-in fade-in-0 duration-200 ease-out',
        className
      )}
    >
      {children}
    </div>
  )
}
